module.exports = __webpack_public_path__ + "static/media/dk.e36b5f15.jpeg";